import { useState, useCallback, useEffect } from "react";
import { utils, providers } from 'ethers';

//move to context eventually

const initWallet = {
  account: undefined,
  network: undefined,
  provider: undefined,
  providerError: undefined
}

export const useWallet = () => {
  const [wallet, setWallet] = useState(initWallet);

  const initialize = useCallback((_account) => {
    if (!_account) {
      disconnect();
      console.log(">>> Account Error");
      return;
    }
    const _wallet = { ...initWallet, account: _account };
    _wallet.network = window.ethereum.networkVersion;
    if (!_wallet.network) {
      disconnect();
      console.log(">>> Network Error");
      return;
    }
    _wallet.provider = new providers.Web3Provider(window.ethereum, "any");
    if (!_wallet.provider) {
      disconnect();
      console.log(">>> Provider Error");
      return;
    }

    _wallet.provider.on("error", (_error) => {
      console.log(">>> Provider Error: ", _error);
      setWallet((w) => ({ ...w, providerError: _error}));
    });

    _wallet.provider.on("network", (newNetwork, oldNetwork) => {
        // When a Provider makes its initial connection, it emits a "network"
        // event with a null oldNetwork along with the newNetwork. So, if the
        // oldNetwork exists, it represents a changing network
        if (oldNetwork) disconnect();
        //console.log("Network Changing from "+oldNetwork+" to "+newNetwork);
    });

    console.log(">>> Wallet Connected: ", _wallet);
    setWallet(_wallet);
  }, []);

  const disconnect = useCallback(() => {
    if (wallet.provider) wallet.provider.removeAllListeners();
    if (window.ethereum) window.ethereum.removeAllListeners();
    window.location.reload();
    console.log(">>> disconnectWallet");
  }, [wallet.provider]);

  const connect = useCallback(async () => {

    const handleEthereum = async () => {
      const [_account] = await window.ethereum.request({ method: 'eth_requestAccounts' });
      //console.log(">>> connectWallet ", _account);
      initialize(_account);

      // We reinitialize it whenever the user changes their account.
      window.ethereum.on("accountsChanged", ([newAddress]) => {
        console.log(">>> accountsChanged event, newAddress: ", newAddress);
        //initialize(newAddress);
        disconnect();
      });
    }

    if (window.ethereum) {
      handleEthereum();
    } else {
      window.addEventListener('ethereum#initialized', handleEthereum, {
        once: true,
      });

      // If the event is not dispatched by the end of the timeout,
      // the user probably doesn't have MetaMask installed.
      setTimeout(handleEthereum, 3000); // 3 seconds
    }
        
  }, [disconnect]);

  

  return {
    ...wallet,
    connect,
    disconnect
  }
}

export const useAccount = () => {
  const {
    provider,
    providerError,
    network,
    account,
    connect,
    disconnect
  } = useWallet();
  const [{ block, balance }, setState] = useState({});

  const blockUpdate = useCallback(async (_block) => {
    try {
      const _balance = await provider.getBalance(account);
      setState({ block: _block.toString(), balance: utils.formatEther(_balance).toString() });
    } catch (e) { console.error(e); }
  }, [provider, account]);

  useEffect(() => {
    if (provider) {
      provider.on("block", blockUpdate);
      return () => provider.off("block", blockUpdate);
    }
  }, [provider]);

  return {
    provider,
    providerError,
    network,
    account,
    connect,
    disconnect,
    block,
    balance
  };
}
